module.exports = __webpack_public_path__ + "static/media/26UNRWA3.c2831f1e.jpg";